<template>
  <div class="content-panel">
    <div class="search-area" v-if="$slots.search">
      <slot name="search"></slot>
    </div>
    <div class="sub-area" v-if="$slots.sub">
      <slot name="sub"></slot>
    </div>
    <div class="main-area">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentPanel'
}
</script>

<style lang="stylus" scoped>
.content-panel
  margin 5px 15px 0
  .search-area, .main-area, .sub-area
    color #606266
    background-color #ffffff
    border-radius 5px
  .search-area
    padding 0 20px
  .main-area
    padding 15px 20px
  .sub-area
    padding 5px 15px
    margin-bottom 10px
</style>